import React from 'react';
import classes from './style.module.css'
import ApplicationLogin from '../../components/ApplicationLogin'
import { Container, Row } from 'react-bootstrap';
import BannerRow from "../BannerRow"
import advertisementImage from "../../assets/images/advertisement.jpg"
import headerImage from '../../assets/images/header.png'


const LoginView = (props) => {

    return (
        <Container className={classes.LoginView} fluid>
            <BannerRow bannerImage={headerImage} />
            <Row className={classes.MiddleRow}>
                <ApplicationLogin />
            </Row>
            <div className={classes.AdvertisementRow}>
                <BannerRow bannerImage={advertisementImage} desturl="http://football-atm.com/ms.htm" />
            </div>
        </Container>
    );
}

export default LoginView;